import { Status } from "../../common/Constants";

export const formGroup = {
  name: { value: "", mandatory: true },
  nik: { value: "", mandatory: true },
  ktpNumber: { value: "", mandatory: true },
  hpnumber: { value: "" },
  email: { value: "" },
  religion: { value: null },
  birthDate: { value: null },
  gender: { value: null },
  npwpNumber: { value: "" },
  taxStatus: { value: "" },
  bpjsNumber: { value: "" },
  bpjsTkNumber: { value: "" },
  address: { value: "" },
  province: { value: null },
  kabKot: { value: null },
  kecamatan: { value: null },
  kelurahan: { value: "" },
  zipCode: { value: null },
  tanggalMasuk: { value: null },
  tanggalResign: { value: null },
  ktpPhoto: { value: "" },
  hirarki: { value: null, mandatory: true },
  ahassLine: { value: null, mandatory: true },
  marketingLine: { value: null, mandatory: true },
  administrationLine: { value: null, mandatory: true },
  employeePhoto: { value: "" },
  signPhoto: { value: "" },
  idrefobj: { value: null, mandatory: true },
  idrole: { value: null, mandatory: true },
  username: { value: "", mandatory: true },
  status: { value: Status.INACTIVE },
  idUser: { value: "" },
  employeeId: { value: "" },
};
